import { HeroCarousel } from "@/components/marketplace"
import type { HeroSlide } from "@/components/marketplace/hero/hero-carousel"
import type { HeroCarouselSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const HeroCarouselFeedSection = ({ section, context }: FeedSectionProps<HeroCarouselSection>) => {
  const slides: HeroSlide[] = section.data.slides.map((slide) => ({
    title: slide.title,
    accent: slide.accent,
    sub: slide.sub,
    cta: slide.cta?.label,
    ctaHref: slide.cta ? resolveFeedLink(slide.cta.link, context.countryCode, context.page) : undefined,
    image: slide.image?.url,
    imageWide: slide.imageWide?.url,
    imageAlt: slide.image?.alt,
    serveId: slide.serveId,
  }))
  if (slides.length === 0) return null
  return (
    <SectionFrame section={section} context={context} ownsHeader>
      <HeroCarousel slides={slides} priority={context.isLeadSection} />
    </SectionFrame>
  )
}
